import React from "react";

import { AgendamientoResumido } from "../../services/agendamientosServicios";
import { isAgendamientoGuarderiaResumido } from "../../services/agendamientosGuarderiaServicios";
import { isAgendamientoHotelResumido } from "../../services/agendamientosHotelServicios";
import { isAgendamientoSpaResumido } from "../../services/agendamientosSpaServicios";
import { AgendamientoResumidoGuarderia } from "../agendamientoResumido/AgendamientoResumidoGuarderia";
import { AgendamientoResumidoHotel } from "../agendamientoResumido/AgendamientoResumidoHotel";
import { AgendamientoResumidoSpa } from "../agendamientoResumido/AgendamientoResumidoSpa";

export const SeccionMascota = ({
  agendamientos,
}: {
  agendamientos: Array<AgendamientoResumido>;
}) => {
  return (
    <section className="mb-4">
      {agendamientos.map((agendamiento) => {
        if (isAgendamientoGuarderiaResumido(agendamiento)) {
          return (
            <AgendamientoResumidoGuarderia
              key={agendamiento.id}
              agendamiento={agendamiento}
            />
          );
        }
        if (isAgendamientoHotelResumido(agendamiento)) {
          return (
            <AgendamientoResumidoHotel
              key={agendamiento.id}
              agendamiento={agendamiento}
            />
          );
        }
        if (isAgendamientoSpaResumido(agendamiento)) {
          return (
            <AgendamientoResumidoSpa
              key={agendamiento.id}
              agendamiento={agendamiento}
            />
          );
        }
        return <></>;
      })}
    </section>
  );
};
